import classnames from "classnames";

import ValidDatesLabel from "../ValidDatesLabel";

type PromoCardProps = {
  content: string;
  title: string;
  startDate: string;
  endDate: string;
  finePrint: string;
  className?: string;
};
const PromoCard: React.FC<PromoCardProps> = ({
  content,
  title,
  startDate,
  endDate,
  finePrint,
  className,
}) => {
  return (
    <div className={classnames("bg-leafly-white p-lg mb-lg", className)}>
      <div className="text-base mb-xxs">{title}</div>
      <ValidDatesLabel isDeal={false} startDate={startDate} endDate={endDate} />
      <hr className="mt-xs mb-md border-deep-green-alt" />
      <p className="text-sm mb-none whitespace-pre-wrap">{content}</p>
      {finePrint && <p className="text-xs mt-lg mb-none">{finePrint}</p>}
    </div>
  );
};

export default PromoCard;
